function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import styled from "styled-components";
import { pxToRem, transition } from "../../private/helpers";
import { paletteHelper, spacingHelper } from "../../utils";
import Label from "../Label";
var heightHelper = _ref => {
  var {
    theme,
    $sizeVariant
  } = _ref;
  var {
    spacing
  } = theme;
  var height = {
    large: spacing.extraLarge,
    medium: spacing.large,
    small: spacing.large
  };
  return height[$sizeVariant] || spacing.extraLarge;
};
var paddingHelper = _ref2 => {
  var {
    theme,
    $sizeVariant
  } = _ref2;
  var {
    spacing
  } = theme;
  var padding = {
    large: pxToRem(11) + " " + spacing.medium,
    medium: pxToRem(7) + " " + spacing.medium,
    small: pxToRem(5) + " " + spacing.small
  };
  return padding[$sizeVariant];
};
var ListboxWrapper = styled.div.withConfig({
  displayName: "styles__ListboxWrapper",
  componentId: "sc-1sw1a31-0"
})(["z-index:", ";width:100%;", ""], _ref3 => {
  var {
    $isPortaled
  } = _ref3;
  return $isPortaled ? 501 : 89;
}, _ref4 => {
  var {
    $popperStyle
  } = _ref4;
  return _extends({}, $popperStyle);
});
var Listbox = styled.ul.withConfig({
  displayName: "styles__Listbox",
  componentId: "sc-1sw1a31-1"
})(["display:", ";border:", ";", ";border-radius:", ";background-color:", ";width:100%;max-height:", ";overflow:auto;outline:none;"], _ref5 => {
  var {
    $visible
  } = _ref5;
  return $visible ? "block" : "none";
}, _ref6 => {
  var {
    theme: {
      border,
      palette
    },
    $isErrored,
    $visible
  } = _ref6;
  return $isErrored ? border.width.thick + " solid " + palette.borderErrored : $visible && border.width.thick + " solid " + palette.borderFocused;
}, _ref7 => {
  var {
    $placement
  } = _ref7;
  return $placement != null && $placement.includes("bottom") ? "border-top: none" : "border-bottom: none";
}, _ref8 => {
  var {
    theme,
    $placement
  } = _ref8;
  return $placement != null && $placement.includes("bottom") ? "0 0 " + theme.border.radius.medium + " " + theme.border.radius.medium : theme.border.radius.medium + " " + theme.border.radius.medium + " 0 0 ";
}, paletteHelper("backgroundPrimaryBase"), _ref9 => {
  var {
    $listboxMaxHeight
  } = _ref9;
  return $listboxMaxHeight;
});
var ListItem = styled.li.withConfig({
  displayName: "styles__ListItem",
  componentId: "sc-1sw1a31-2"
})(["color:inherit;list-style-type:none;text-indent:0;overflow-x:hidden;white-space:nowrap;text-overflow:ellipsis;user-select:none;padding:", ";font-size:", ";line-height:", ";"], paddingHelper, _ref10 => {
  var {
    $sizeVariant,
    theme
  } = _ref10;
  return $sizeVariant === "small" ? theme.typography.body02.fontSize : theme.typography.body01.fontSize;
}, _ref11 => {
  var {
    $sizeVariant,
    theme
  } = _ref11;
  return $sizeVariant === "small" ? theme.typography.body02.lineHeight : theme.typography.body01.lineHeight;
});
var ListboxOption = styled(ListItem).withConfig({
  displayName: "styles__ListboxOption",
  componentId: "sc-1sw1a31-3"
})(["display:flex;align-items:center;cursor:pointer;", ";transition:", ";& p{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}& > div:last-child{overflow:hidden;}&:active{background-color:", ";}"], _ref12 => {
  var {
    $isActive,
    theme
  } = _ref12;
  if ($isActive) {
    return "\n        background-color: " + theme.palette.backgroundFocusedPrimary + ";\n        color: " + theme.palette.textPrimary + ";";
  }
}, transition("background-color"), paletteHelper("backgroundPressedPrimary"));
var NoResultsListItem = styled(ListItem).withConfig({
  displayName: "styles__NoResultsListItem",
  componentId: "sc-1sw1a31-4"
})(["color:", ";"], paletteHelper("textSecondary"));
var StyledLabel = styled(Label).withConfig({
  displayName: "styles__StyledLabel",
  componentId: "sc-1sw1a31-5"
})(["margin-bottom:", ";"], spacingHelper("twoExtraSmall"));
var ComponentContainer = styled.div.withConfig({
  displayName: "styles__ComponentContainer",
  componentId: "sc-1sw1a31-6"
})(["text-align:left;position:relative;& > * + *{position:relative;}"]);
var ContentWrapper = styled.div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-1sw1a31-7"
})(["width:100%;display:flex;flex-wrap:wrap;"]);
var IconWrapper = styled.div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-1sw1a31-8"
})(["align-items:center;display:flex;height:", ";", ";", ""], heightHelper, _ref13 => {
  var {
    $position,
    theme
  } = _ref13;
  return "margin-" + ($position === "left" ? "right" : "left") + ": " + theme.spacing.medium;
}, _ref14 => {
  var {
    $disabled,
    theme
  } = _ref14;
  return $disabled && "color: " + theme.palette.textDisabled + ";";
});
var OptionIconWrapper = styled.div.withConfig({
  displayName: "styles__OptionIconWrapper",
  componentId: "sc-1sw1a31-9"
})(["display:flex;align-items:center;margin-right:", ";"], spacingHelper("small"));
export { NoResultsListItem, ListboxWrapper, Listbox, ListboxOption, StyledLabel, ComponentContainer, ContentWrapper, IconWrapper, OptionIconWrapper };